import { useHttpClient } from './httpClient';

const resource = 'action_logs';


export function fetchActionLogParams() {
	return useHttpClient().get(`/${resource}/params`);
}

export function fetchActionLogs(serverId, date) {
	return useHttpClient().get(`/${resource}`, { params: { serverId, date } });
}
